// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Kbaf","title":"Info_title__16WSX","links":"Info_links__486h4","link":"Info_link__2MGW9","logo":"Info_logo__35NKm"};